import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-error-screen',
    templateUrl: './error-screen.component.html',
    styleUrls: ['./error-screen.component.scss']
})
export class ErrorScreenComponent {

    @Input() showErrorScreen: boolean;
    @Input() errorTitle: string;
    @Input() errorMessage: string;
    @Input() primaryCtaText: string;

    @Output() errorCtaClicked: EventEmitter<any> = new EventEmitter();


    handleErrorCtaClick() {
        this.errorCtaClicked.emit();
    }
}
